// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__91-oY"};